import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ValidationsService } from '../../services/common/validations.service';
import { PreloginService } from '../../services/prelogin.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-counsellor-registration',
  templateUrl: './counsellor-registration.component.html',
  styleUrls: ['./counsellor-registration.component.scss']
})
export class CounsellorRegistrationComponent implements OnInit {

  constructor(private formBuilder: FormBuilder, private router: Router, private validationService: ValidationsService, private preLoginService: PreloginService) { }

  // flags
  isSignUpCompleted = false;
  isLoading = false;

  // defaults
  partnerName = null;
  partnerId = null;
  counsellorEmail = null;

  isFormSubmitted = false;
  isUserAlreadyExists = false;

  signUpForm: FormGroup;

  // password toggle
  isFieldTypeText = false;

  ngOnInit() {

    if (localStorage.getItem('counsellorSign_partner_name') != null && localStorage.getItem('counsellorSign_partner_id') != null && (localStorage.getItem('counsellorSign_email') != null)) {
      this.partnerName = localStorage.getItem('counsellorSign_partner_name');
      this.partnerId = localStorage.getItem('counsellorSign_partner_id');
      this.counsellorEmail = localStorage.getItem('counsellorSign_email');
    }

    this.signUpForm = this.formBuilder.group({
      partner_id: [this.partnerId],
      email: [this.counsellorEmail],
      name: ['', Validators.required],
      phone: ['', [Validators.required, Validators.maxLength(10), Validators.pattern('[1-9][0-9]{9}')]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });
  }

  // getters
  get name() { return this.signUpForm.get('name'); }
  get phone() { return this.signUpForm.get('phone'); }
  get email() { return this.signUpForm.get('email'); }
  get password() { return this.signUpForm.get('password'); }

  // It is for numeric input, need to place it globally so that can be utilized anywhere
  // phone no.
  onlyNumericInput(event) {
    return this.validationService.isNumericInput(event);
  }

  togglePasswordFieldType() {
    this.isFieldTypeText = !this.isFieldTypeText;
  }

  signUpFormSubmit() {

    this.isFormSubmitted = true;

    if (this.signUpForm.invalid) {
      return;
    }
    this.preLoginService.counselorRegistration(this.signUpForm.value).subscribe(response => {
      console.log(response);

      if (response.statusCode == 200 && response.status == false) {
        this.isUserAlreadyExists = response.message;
      }
      else {
        this.isFormSubmitted = false;

        const autoLoginPostData = {
          email: this.email.value,
          password: this.password.value
        };

        this.signUpForm.reset();
        localStorage.clear();

        this.preLoginService.login(autoLoginPostData).subscribe(data => {
          this.router.navigate(['/my-dashboard']);
        });
      }
    });
  }

}
